import React, { Component, createRef } from "react";
import "component/listItem/FreeRoundsType/styles.scss";
import freeRoundsDefault from "assets/images/freeRoundsDefault.png";
import iconDefault from "assets/images/iconDefault.png";
import { isEqual } from "lodash";
import { formatTimeRemaining } from "utils/date";
import { currencyFormatter } from "utils/currencyHelper";
import { withNamespaces } from "react-i18next";
import resize2fit from "utils/resizeHelper";

import translations from "translations";

class FreeRoundsType extends Component {
  constructor(props) {
    super(props);

    this.onMouseOverHandler = this._onMouseOverHandler.bind(this);
    this.iconRef = createRef();
    this.iconDefaultRef = createRef();
    this.mainComponent = createRef();

    this.state = {
      hovered: false,
      isVisible: false,
    };
  }

  componentDidMount() {
    this.initObserver();
  }

  initObserver() {
    if (
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    ) {
      let observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (this.mainComponent.current) {
                this.setState({
                  isVisible: true,
                });
              }
            }
          });
        },
        {
          rootMargin: "0px 0px 0px 0px",
        }
      );
      observer.observe(this.mainComponent.current);
    } else {
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.game, this.props.game)) {
      this.setState(
        {
          reloadJpPool: false,
        },
        () => {
          this.setState({
            reloadJpPool: true,
          });
        }
      );
    } else {
      this.setState({
        reloadJpPool: false,
      });
    }
  }

  componentWillUnmount() {
    if (this.props.game) {
      window.cancelAnimationFrame(this.animationFrameId);
    }
  }

  _onMouseOverHandler(bol) {
    this.setState({
      hovered: bol,
    });
  }

  renderStatus() {
    let { t } = this.props;
    let status = this.props.game.get("status");
    let endsIn = this.props.game.get("endsIn");

    switch (status) {
      case "COMPLETED":
      case "NEW":
      case "EXPIRED":
      case "FAILED":
        return (
          <div className="status">{translations(status.toLowerCase())}</div>
        );
      default:
        let endsInObj = formatTimeRemaining(endsIn);
        return (
          <div className="remaining">
            {endsInObj.d &&
              endsInObj.d === 1 &&
              t("expiresInDay", { days: endsInObj.d })}
            {endsInObj.d &&
              endsInObj.d !== 1 &&
              t("expiresInDays", { days: endsInObj.d })}
            {endsInObj.w &&
              endsInObj.w === 1 &&
              t("expiresInWeek", { weeks: endsInObj.w })}
            {endsInObj.w &&
              endsInObj.w !== 1 &&
              t("expiresInWeeks", { weeks: endsInObj.w })}
            {endsInObj.m &&
              endsInObj.m === 1 &&
              t("expiresInMonth", { months: endsInObj.m })}
            {endsInObj.m &&
              endsInObj.m !== 1 &&
              t("expiresInMonths", { months: endsInObj.m })}
          </div>
        );
    }
  }

  renderbutton() {
    let { t } = this.props;
    let gamesLink;
    let realLink;
    let resultsLink;

    try {
      resultsLink = this.props.game
        .get("links")
        .find((link) => link.get("rel") === "rewards.game-rounds");
    } catch (err) {}

    try {
      realLink = this.props.game
        .get("links")
        .find((link) => link.get("rel") === "launch.real");
    } catch (err) {}

    try {
      gamesLink = this.props.game
        .get("links")
        .find((link) => link.get("rel") === "rewards.games");
    } catch (err) {}

    if (realLink)
      return (
        <div
          className="btn btn-danger btn-sm btn-rnd w-100"
          onClick={(event) => {
            event.stopPropagation();
            this.props.continuePlaying();
          }}
        >
          {t("continuePlaying")}
        </div>
      );

    if (gamesLink)
      return (
        <div className="btn btn-danger btn-sm btn-rnd w-100">
          {t("activateNow")}
        </div>
      );

    if (resultsLink)
      return (
        <div className="btn btn-secondary btn-sm btn-rnd w-100 d-none">
          {t("viewResults")}
        </div>
      );

    return;
  }

  render() {
    const { game } = this.props;
    const isNotActive =
      this.props.game &&
      ["EXPIRED", "FAILED"].includes(this.props.game.get("status"));

    resize2fit(document.querySelectorAll(".bet-container"));

    return (
      <div
        className={`${this.props.className} free-rounds-type ${
          game ? game.get("id") : ""
        }`}
        onMouseOver={() => {
          this.onMouseOverHandler(true);
        }}
        onMouseOut={() => {
          this.onMouseOverHandler(false);
        }}
        onClick={(event) => {
          event.stopPropagation();
          if (this.props.onClick) {
            this.props.onClick();
          }
        }}
        ref={this.mainComponent}
      >
        <div>
          <div>
            <div className={`img-holder ${isNotActive ? "inactive" : ""}`}>
              {game && this.state.isVisible && (
                <img
                  ref={this.iconRef}
                  src={freeRoundsDefault}
                  className="icon d-none"
                  alt={game.get("title")}
                  onLoad={({ currentTarget }) => {
                    currentTarget.classList.remove("d-none");
                    this.iconDefaultRef.current.classList.add("d-none");
                  }}
                />
              )}
              <img
                ref={this.iconDefaultRef}
                src={iconDefault}
                className="icon"
                alt="dummy"
              />
              {this.props.game && this.props.game.get("totalBetValue") && (
                <div className="h-100 w-100 d-flex justify-content-center align-items-center amount bet-container">
                  <div className="text-center">
                    {currencyFormatter(this.props.game.get("totalBetValue"), {
                      currency: this.props.currency,
                    })}
                  </div>
                </div>
              )}
              {this.props.game && this.renderStatus()}
            </div>
            {game && (
              <div className="details d-flex align-items-center">
                <div className="w-100">
                  <div className="w-100 title">{game.get("title")}</div>
                  {this.renderbutton()}
                </div>
              </div>
            )}

            {!game && (
              <div className="details d-flex align-items-center">
                <div className="w-100">
                  <div className="w-100 title">
                    <span className="dummy">XXXXXXXXXXXXX</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withNamespaces("translation")(FreeRoundsType);
